import {Component, inject, Input} from '@angular/core';
import {SuperObjectModel} from '../../core/definitions/super-object-model';
import {SearchObject} from '../../core/definitions/search-object';
import {RefService} from '../../core/ref.service';
import {FeatureFlagsService} from '../../core/feature-flags.service';
import {Router} from '@angular/router';
import {StateParams} from "../../core/definitions/state-params";
import {RefParams} from "../../core/definitions/ref-params";
import {RefData} from "../../core/definitions/ref-data";

@Component({
  selector: 'app-recto-verso-buttons',
  templateUrl: './recto-verso-buttons.component.html',
  styleUrls: ['./recto-verso-buttons.component.scss'],
  standalone: false
})
export class RectoVersoButtonsComponent {
  // Injections
  private readonly featureFlagsService: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly ref: RefService = inject(RefService);
  private readonly router: Router = inject(Router);

  @Input() object: SuperObjectModel;

  get hasRectoVerso(): boolean {
    return (this.object?.recto_verso && !!this.object.recto_verso.relation_id) ||
      (this.object?.verso_recto && !!this.object.verso_recto.context_id);
  }

  get isRecto(): boolean {
    return !!this.object?.recto_verso?.relation_id;
  }

  get isVerso(): boolean {
    return !this.isRecto && !!this.object?.verso_recto?.context_id;
  }

  get rectoObject(): SuperObjectModel {
    const obj = new SuperObjectModel();
    obj.artifact_id = this.object?.verso_recto?.context_id || this.object?.artifact_id;
    return obj;
  }

  get versoObject(): SuperObjectModel {
    const obj = new SuperObjectModel();
    obj.artifact_id = this.object?.recto_verso?.relation_id || this.object?.artifact_id;
    return obj;
  }

  async goToSearchItem(item: SearchObject) {
    if (item) {
      const url = ['/artifact']
      const refInfo = await this.createRef(item);
      if (this.featureFlagsService.getFeatureFlags().experimental.useNewObjectPage) {
        url.push(item.artifact_id, 'overview')
      }

      await this.router.navigate(url, {
        queryParams: refInfo.queryParams,
        queryParamsHandling: 'merge'
      })
    }
  }

  private async createRef(searchItem: SearchObject): Promise<RefData> {
    const params = new RefParams(searchItem);
    params.searchItemIndex = null;
    params.rootObjId = null;
    params.rootObjType = null;
    params.stateParams = {
      listName: 'overview'
    } as StateParams;
    return await this.ref.makeRef(params);
  }
}
